import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { CommonModule } from '@angular/common';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzImageModule } from 'ng-zorro-antd/image';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-terms-policy',
  standalone: true,
  imports: [
    CommonModule,
    NzGridModule,
    NzSkeletonModule,
    NzButtonModule,
    NzDividerModule,
    NzImageModule,
    TranslateModule
  ],
  templateUrl: './terms-policy.component.html',
  styleUrls: ['./terms-policy.component.scss'],
})
export class TermsPolicyComponent implements OnInit {
  urlIMG = environment.urlIMG;

  constructor() {}

  ngOnInit(): void {}
}
